import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import PracticaTipoSolDenunciaInt from "./PracticaTipoSolDenunciaInt";

import { setearValorEnPractica } from "../../../actions/autorizaciones/Autorizaciones";

export const AutorizacionesPracticaPendienteDenuncia = (props) => {
  const { conInternacion } = props;
  const dispatch = useDispatch();
  const [cantidad, setCantidad] = useState(
    props.practica ? props.practica?.cant : 1
  );

  const { practicasPendientesDenuncia: practicas = [] } = useSelector((state) => state.autorizaciones);

  const mostrarMateriales = false;      //por ahora no pueden cargar materiales en OspeDirecto
  const tieneEfectorInstitucional =
    practicas.find((practica) => practica.idCodNom === props.practica.idCodNom)
      .idCartillaPrestador !== null;
  const tieneIdPrescriptor =
    practicas.find((practica) => practica.idCodNom === props.practica.idCodNom)
      .idPrescriptor !== null;
  const tieneMinimoUnMaterial =
    practicas.find((practica) => practica.idCodNom === props.practica.idCodNom)
      .materiales?.length > 0;

  const validateEmail = (email) => {
    let reg = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    if (reg.test(email) || email?.length === 0) {
      return false;
    } else {
      return true;
    }
  };

  const verifyContacto = (name, value) => {
    if (name === "emailEfectorI") return validateEmail(value);
    else if (/\D/.test(value) || value.length !== 10) return true;
    else return false;
  };

  const handleInputContactosEfectorIChange = ({ target }) => {
    dispatch(
      setearValorEnPractica(props.practica?.idCodNom, target.name, target.value)
    );
    dispatch(
      setearValorEnPractica(
        props.practica?.idCodNom,
        target.name === "emailEfectorI"
          ? "emailEfectorIError"
          : "celularEfectorIError",
        target.value ? verifyContacto(target.name, target.value) : false
      )
    );
  };
  return (
    <React.Fragment>
      <PracticaTipoSolDenunciaInt
        practica={props.practica}
        cantidad={cantidad}
        setCantidad={setCantidad}
        disabled={props.disabled}
        conInternacion={conInternacion}
        mostrarMateriales={mostrarMateriales}
        tieneMinimoUnMaterial={tieneMinimoUnMaterial}
        tieneEfectorInstitucional={tieneEfectorInstitucional}
        tieneIdPrescriptor={tieneIdPrescriptor}
        handleInputContactosEfectorIChange={
          handleInputContactosEfectorIChange
        }
        desdeAuditar={props.desdeAuditar}
        evaluarPracticasMateriales={props.evaluarPracticasMateriales}
        esDenunciaInternacion={props.esDenunciaInternacion}
        filtros={props.filtros}
        pendiente={true}
      />
    </React.Fragment>
  );
};
